import { render, staticRenderFns } from "./No28.vue?vue&type=template&id=7961a339&scoped=true"
import script from "./No28.vue?vue&type=script&lang=js"
export * from "./No28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7961a339",
  null
  
)

export default component.exports